<div class="header w-full px-spacing-3xl py-spacing-xs flex justify-content-between align-items-center gap-spacing-xs border-bottom-1 border-neutral-base-primary-border">
  <h5 class="mb-0 text-base uppercase font-semibold line-height-3">Actions</h5>
  <app-button
    [iconOnlyButton]="true"
    icon="icon-x"
    sizeClass="p-button-sm"
    severity="primary"
    [outlinedButton]="true"
    (btnClick)="ref.close()"></app-button>
</div>

<div class="content px-spacing-xs">
  <app-ride-actions
    [favoriteActions]="config.data.favoriteActions"
    [rideActionsMap]="config.data.rideActionsMap"
    [actionsMenuItems_1]="config.data.actionsMenuItems_1"
    [actionsMenuItems_2]="config.data.actionsMenuItems_2"
    [actionsMenuItems_3]="config.data.actionsMenuItems_3"></app-ride-actions>
</div>
